module.exports = __webpack_public_path__ + "img/soup-cans.a8dcab7c.svg";